export default __webpack_public_path__ + "static/logo-negative-af7dfaccebc7b7671cd31338d90d7eb2.svg";